export default __webpack_public_path__ + "static/SEC_Filings_02-5ae69cd2627a0ae7858df8f5496a6c68.jpg";